import React from "react";
import block from "bem-css-modules";
import column from "../../styles/components/Twocolumn.module.scss";

export default function TwoColumn({heading, leftText, rightText}) {

  block.setSettings({
    modifierDelimiter: "--",
  });

const two = block(column);

  return (
      <div className={two("")}>
        <div className={two("wrapper")}>
          <section className={two('column')}>
          <article className={two("text")}><h3 className={`${two("head")}` + ' ' + `${ !heading && two("head--hide")}`}>{heading}</h3><p className={two("para")}>{leftText || ''}</p> </article>
          <article className={two("text")}><h3 className={`${two("head")}` + ' ' + `${ !heading && two("head--hide")}`}>{heading}</h3><p className={two("para")}>{rightText || ''}   </p> </article>
          {/* <article className={two("text")}><h3 className={`${two("head")}` + ' ' + `${ !heading && two("head--hide")}`}>Heading</h3><p className={two("para")}>{leftText || ''} </p> </article>                       */}
          </section>
        </div>
      </div>
  )
}